import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';

// Two separate caches (rather than reconfiguring one) so switching direction never leaves stale
// flipped CSS behind.
export const ltrCache = createCache({ key: 'mui-ltr', stylisPlugins: [prefixer] });

export const rtlCache = createCache({ key: 'mui-rtl', stylisPlugins: [prefixer, rtlPlugin] });
